'use strict';

exports.__esModule = true;
var html = document.getElementsByTagName('html')[0];
var lang = html.getAttribute('lang') || 'en_US';
var locale = lang.replace('_', '-');
var User = {
	getLocale: function getLocale() {
		return locale;
	}
};

exports['default'] = User;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-i18n/dist/user.js
// module id = 186
// module chunks = 0 1 2 4 5 6